import { canHashSha256, hashSha256 } from '@change-corgi/core/crypto';

import { setPxParamVariable } from 'src/app/shared/utils/perimeterx';

const emailDomain = (email: string): string => email.split('@')[1];

type PxUserData = {
	id?: string;
	email?: string;
	createdAt?: string | null;
};

// FIXME ideally we would want to retrieve viewer.perimeterXConfig here to update the data
// or retrieve emailDomain/emailHash directly from the User GQL type
export async function setPxUserData(user?: PxUserData): Promise<void> {
	if (!user) return;

	const { id: userId, email, createdAt } = user;

	if (userId) setPxParamVariable('userId', userId);
	if (email) {
		setPxParamVariable('emailDomain', emailDomain(email));
		// crypto.subtle is unavailable on local-change.org (HTTP, not HTTPS) and within TestCafe.
		// Omitting the hash in those environments is not a security issue: emailHash is a
		// PerimeterX fraud-detection signal, not a secret or auth credential.
		if (canHashSha256()) {
			setPxParamVariable('emailHash', await hashSha256(email));
		}
	}
	if (createdAt) setPxParamVariable('accountDate', createdAt);
}
